import { render, staticRenderFns } from "./MessageTicketForm.vue?vue&type=template&id=a9d688bc&scoped=true&"
import script from "./MessageTicketForm.vue?vue&type=script&lang=js&"
export * from "./MessageTicketForm.vue?vue&type=script&lang=js&"
import style0 from "./MessageTicketForm.vue?vue&type=style&index=0&id=a9d688bc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../nodevenv/public_html/de.jeanmarcphilippe.com/shop.digipart.fr/16/lib/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9d688bc",
  null
  
)

export default component.exports